import { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import { applicationServiceAPI } from "../../http/http";
import { toast } from "react-toastify";
import ViewApplication from "../../components/partials/application-portal/ViewApplication";
import useUserProfile from "../../customHooks/useUserProfile";
import { ApplicationData } from "../../types/application.type";

const ViewApplicationPage = () => {
  const {id:applicationId} = useParams();
  const [userProfile] = useUserProfile();
  const [applicationData, setApplicationData] =
    useState<ApplicationData | null>(null);
  const [isLoading,setIsLoading] = useState(false);
  useEffect(() => {
    const fetchApplication = async () => {
      setIsLoading(true);
      try {
        const response = await applicationServiceAPI.get(`applications/${applicationId}`);
        console.log(response);
        setApplicationData(response.data.data.application);
      } catch (err: any) {
        console.error(err);
        toast.error(err.message ?? 'Failed to load metrics');
      } finally {
        setIsLoading(false);
      }
    };

    fetchApplication()
  }, []);

  const basicData = useMemo(() => {
    return [
      { field: "Name", name: `${applicationData?.firstName??''} ${applicationData?.surname??''} `},
      { field: "Birthday", name: applicationData?.birthDate ?? "" },
      { field: "Gender", name: applicationData?.surname ?? "" },
    ];
  }, [applicationData]);

  const contactData = useMemo(() => {
    return [
      { field: "Email", name: applicationData?.email ?? "" },
      {
        field: "Active Phone Number",
        name: applicationData?.mobileNumber ?? "",
      },
      { field: "WhatsApp Number", name: applicationData?.mobileNumber ?? "" },
      {
        field: "Residential Address",
        name: applicationData?.residentialAddress ?? "",
      },
      { field: "Postal Address", name: applicationData?.altAddress ?? "" },
      { field: "Nationality", name: applicationData?.shsTeacher ?? "" },
    ];
  }, [applicationData]);

  const paymentData = useMemo(() => {
    return [
      { field: "Mobile Number", name: applicationData?.mobileNumber ?? "" },
      {
        field: "Bank Account Number",
        name: applicationData?.schoolFinance ?? "",
      },
    ];
  }, [applicationData]);

  const educationData = useMemo(() => {
    return [
      { field: "Tertiary", name: applicationData?.schoolInfo ?? "" },
      { field: "Secondary", name: applicationData?.shsSchoolName ?? "" },
    ];
  }, [applicationData]);

  const guarantorData = useMemo(() => {
    return [
      { field: "Guarantor Name", name: applicationData?.guarantorName ?? "" },
    ];
  }, [applicationData]);

  const docData = useMemo(() => {
    return [
      {
        field: "Admission Letter",
        name: applicationData?.admissionLetter ?? "",
      },
      { field: "Ghana Card", name: applicationData?.studentID ?? "" },
    ];
  }, [applicationData]);

  return (
    <div className="">
      {applicationData && (
        <ViewApplication
          title={"Application"}
          description={`Application - ${applicationData.schoolName??''}`}
          subtitle={"Application type"}
          applicationType={applicationData.type}
          applicationStatus={applicationData.currentState}
          userProfile={
            userProfile
              ? {
                  name: userProfile.name,
                  imageUrl: userProfile.imageUrl,
                }
              : { name: "", imageUrl: "" }
          }
          basicTable={{
            columns: [
              { Header: "Field", accessor: "field" },
              { Header: "Name", accessor: "name" },
            ],
            data: basicData,
          }}
          contactTable={{
            columns: [
              { Header: "Field", accessor: "field" },
              { Header: "Name", accessor: "name" },
            ],
            data: contactData,
          }}
          paymentTable={{
            columns: [
              { Header: "Field", accessor: "field" },
              { Header: "Name", accessor: "name" },
            ],
            data: paymentData,
          }}
          educationTable={{
            columns: [
              { Header: "Field", accessor: "field" },
              { Header: "Name", accessor: "name" },
            ],
            data: educationData,
          }}
          guarantorTable={{
            columns: [
              { Header: "Field", accessor: "field" },
              { Header: "Name", accessor: "name" },
            ],
            data: guarantorData,
          }}
          docTable={{
            columns: [
              { Header: "Field", accessor: "field" },
              { Header: "Name", accessor: "name" },
            ],
            data: docData,
          }}
        />
      )}
    </div>
  );
}

export default ViewApplicationPage;
